import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let FacebookIcon = class FacebookIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = '24';
    }
    render() {
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M22.675 0H1.325C.595 0 0 .587 0 1.31v21.38C0 23.413.595 24 1.325 24H12.82v-9.294H9.692v-3.63h3.128V8.413c0-3.1 1.894-4.788 4.658-4.788 1.325 0 2.465.099 2.797.143v3.24h-1.919c-1.505 0-1.797.715-1.797 1.765v2.317h3.59l-.467 3.63h-3.123V24h6.127c.73 0 1.324-.587 1.324-1.31V1.31C24 .587 23.405 0 22.675 0z"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
      </svg>
    `;
    }
};
FacebookIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], FacebookIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], FacebookIcon.prototype, "size", void 0);
FacebookIcon = __decorate([
    customElement('facebook-icon')
], FacebookIcon);
var FacebookIcon$1 = FacebookIcon;

export { FacebookIcon$1 as default };
//# sourceMappingURL=facebookIcon.js.map
